import { render, staticRenderFns } from "./DiplomatiSafiran.vue?vue&type=template&id=78c14141&scoped=true&"
import script from "./DiplomatiSafiran.vue?vue&type=script&lang=js&"
export * from "./DiplomatiSafiran.vue?vue&type=script&lang=js&"
import style0 from "./DiplomatiSafiran.vue?vue&type=style&index=0&id=78c14141&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c14141",
  null
  
)

export default component.exports